jQuery(document).on('ready', function () {
    const $sliders = jQuery('[data-card-slider]');

    $sliders.each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            swipeToSlide: false,
            infinite: true,
            cssEase: 'ease',
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            arrows: false,
            pauseOnHover: false,
        });
    });
});
